import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {LOTES_STATUS} from "../../utils/constant";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#01796F',
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function LandTableInformation({ rows }) {
    return (
        <TableContainer component={Paper} sx={{ marginBottom: '20px' }} className='lotes'>
            <Table aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell># Solar</StyledTableCell>
                        <StyledTableCell align="right">Metros&nbsp;(m2)</StyledTableCell>
                        <StyledTableCell align="right">Precio por Metro $USD</StyledTableCell>
                        {/*<StyledTableCell align="right">Total $USD</StyledTableCell>*/}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <StyledTableRow key={row.id}>
                            <StyledTableCell component="th" scope="row" sx={{ fontWeight: 'bold', ...(row.status !== LOTES_STATUS.AVAILABLE && { color: 'red' }) }}>
                                {row.loteID}
                            </StyledTableCell>
                            <StyledTableCell align="right" sx={{ fontWeight: 'bold', ...(row.status !== LOTES_STATUS.AVAILABLE && { color: 'red' }) }}>
                                {row.status === LOTES_STATUS.AVAILABLE ? row.meters.toLocaleString("en-US") : row.status}
                            </StyledTableCell>
                            <StyledTableCell align="right" sx={{ fontWeight: 'bold', ...(row.status !== LOTES_STATUS.AVAILABLE && { color: 'red' }) }}>
                                {row.status === LOTES_STATUS.AVAILABLE? row.pricePerMeter:null}
                            </StyledTableCell>
                            {/*<StyledTableCell align="right" sx={{ fontWeight: 'bold', ...(row.status !== LOTES_STATUS.AVAILABLE && { color: 'red' }) }}>*/}

                            {/*    {row.status === LOTES_STATUS.AVAILABLE? (row.meters* row.pricePerMeter).toLocaleString("en-US"):null}*/}
                            {/*</StyledTableCell>*/}
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
